// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Mj1A","toggleWrap":"styles_toggleWrap__2jO3L","content":"styles_content__33C3T","selectAreaCode":"styles_selectAreaCode__2jmwD"};